module.exports = __webpack_public_path__ + "img/authenticationSuccess.5279683e.png";